export default __webpack_public_path__ + "static/media/image4.ffa3bdc1.jpg";